import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

/**
 * Hook to get the current company's timezone
 * @returns The company timezone string or null if not available
 */
export const useCompanyTimeZone = () => {
  const { user } = useAuth();
  const [companyTimeZone, setCompanyTimeZone] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCompanyTimeZone = async () => {
      if (!user?.companyId) {
        setCompanyTimeZone('America/New_York'); // Fallback to default
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);
        
        const response = await apiService.getCompanyById(user.companyId);
        if (response.success && response.data) {
          setCompanyTimeZone(response.data.timeZone || 'America/New_York');
        } else {
          setCompanyTimeZone('America/New_York'); // Fallback to default
        }
      } catch (err) {
        console.error('Failed to get company timezone:', err);
        setError('Failed to load company timezone');
        setCompanyTimeZone('America/New_York'); // Fallback to default
      } finally {
        setIsLoading(false);
      }
    };

    fetchCompanyTimeZone();
  }, [user?.companyId]);

  return { companyTimeZone, isLoading, error };
};
